import { animate, state, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ToastExtended } from '../../models/toast.model';
import { ScreenDimensionService } from '../../services/screen-dimension.service';
import { ToastService } from '../../services/toast.service';
import { ToastNotificationComponent } from './toast-notification.component';

@Component({
  selector: 'app-toast-notification-container',
  templateUrl: './toast-notification-container.component.html',
  styleUrls: ['./toast-notification-container.component.scss'],
  imports: [ToastNotificationComponent, CommonModule],
  animations: [
    trigger('toastAnimationMobile', [
      state('void', style({ transform: 'translateY(100%)', opacity: 0 })),
      state('visible', style({ transform: 'translateY(0)', opacity: 1 })),
      transition('void => visible', [animate('300ms ease-out')]),
      transition('visible => void', [animate('300ms ease-in')]),
    ]),
    trigger('toastAnimationDesktop', [
      state('void', style({ transform: 'translateY(-100%)', opacity: 0 })),
      state('visible', style({ transform: 'translateY(0)', opacity: 1 })),
      transition('void => visible', [animate('300ms ease-out')]),
      transition('visible => void', [animate('300ms ease-in')]),
    ]),
  ],
})
export class ToastNotificationContainerComponent {
  toasts$ = this.toastService.toasts$;
  isMobileWidth$ = this.screenDimensions.isBelowMedium$;

  removeToast(toast: ToastExtended) {
    this.toastService.removeToast(toast);
  }

  constructor(
    private readonly toastService: ToastService,
    private readonly screenDimensions: ScreenDimensionService
  ) {}
}
